<template>
  <button
    :class="componentClasses"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <i :class="icon" />
  </button>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    default: 'fas fa-chevron-down',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  inherit: {
    type: Boolean,
    default: false,
  },
});

const componentClasses = computed(() => [
  'stk-icon is-button',
  props.inherit || 'primary-color',
  props.inherit && 'inherit-color',
]);
</script>

<style>
.stk-icon.is-button {
  cursor: pointer;

  &[disabled] {
    box-shadow: none;
    opacity: 0.5;
    pointer-events: none;
  }

  &.primary-color {
    color: var(--stk-primary);
  }
}
</style>
